interface BrandWordmarkProps {
  size?: "sm" | "default";
}

export function BrandWordmark({ size = "default" }: BrandWordmarkProps) {
  const textClass = size === "sm" ? "text-base font-bold" : "text-lg sm:text-xl font-bold";

  return (
    <span
      className={`${textClass} whitespace-nowrap`}
      data-testid="text-brand-wordmark"
    >
      TrOOp
      <span className="text-[0.85em] text-brand-gold font-bold relative" style={{ top: "-0.3em" }}>N</span>
    </span>
  );
}
